import styled, { css } from 'styled-components';
import { breakpoints } from 'shared/utils/styles';

const getFontSize = (baseFontSize, value, units) => {
  const isNotNegative = value >= 0;
  if (isNotNegative) return `${baseFontSize + Number(`.${value}`)}${units}`;
  return `${baseFontSize + -Number(`.${Math.abs(value)}`)}${units}`;
}

export const Container = styled.div`
${({ bidActivityFontSize }) => css`
  grid-area: bid-activity;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #eee;
  border: 1px solid gray;
  padding: 0px 5px;
  text-transform: uppercase;
  > div:first-child {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  min-width: 100%;
  align-items: center;
  z-index: 1;
  & > div:nth-child(1) {
    display: flex;
    justify-content: space-between;
    width: 100%;
    & > div:nth-child(1) {
      width: 25%;
    }
    & > div:nth-child(2) {
      width: 50%;
      text-transform: uppercase;
      font-size: 2em;
      @media (max-width: ${breakpoints.auctioneer.small}) {
        font-size: 1.7em;
      }
      font-weight: bold;
      padding-top: 5px;
      border-bottom: 1px solid gray;
      margin-bottom: 5px;
      text-align: center;
    }
    & > div:nth-child(3) {
      width: 25%;
      padding-top: 3px;
      display: flex;
      align-items: flex-start;
      justify-content: flex-end;
    }
  }
  & > div:not(:first-child) {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    min-height: 100%;
    min-width: 100%;
    font-size: ${getFontSize(1.5, bidActivityFontSize, 'em')};
    @media (max-width: ${breakpoints.auctioneer.small}) {
      font-size: ${getFontSize(.9, bidActivityFontSize, 'em')};
    }
  }
  }
`}`;

export const BidActivityIcon = styled.i`
  color: ${(props) => props.color ?? 'black'};
`;

export const Item = styled.div`
  display: flex;
  align-items: center;
  padding: 2px 10px;
  margin: 0px 0px;
  background-color: ${(props) => (props.bgColor === '#e7e7e7' ? '#eee' : props.bgColor)};
  border-radius: 5px;
  color: ${(props) => props.color};
  & i {
    font-size: 1.2em;
    padding-right: 5px;
    color: ${(props) => props.color};
  }
`;

export const ItemList = styled.div`
  min-height: 0;
  padding-left: 15px;
`;

export const ItemData = styled.div`
  padding-left: 0px;
  padding-right: 0px;
`;

export const ItemTitle = styled.div`
  color: ${(props) => props.color};
`;
